import React from 'react';
import { motion } from 'framer-motion';
export function BenefitsSection() {
  const benefits = [{
    title: '30 posts listos y programados',
    desc: 'Todo el mes publicándose automáticamente mientras tú cierras ventas o disfrutas tu familia.'
  }, {
    title: 'Diseños profesionales sin diseñador',
    desc: '30 piezas visuales creadas en Canva con IA en lote. Estética de agencia, costo de cero.'
  }, {
    title: 'Tu voz — no la de un robot',
    desc: 'La técnica de Muestreo de Estilo hace que la IA aprenda cómo hablas. Tus seguidores no sabrán la diferencia.'
  }, {
    title: 'Presencia en todas las plataformas',
    desc: 'TikTok, Instagram, LinkedIn y YouTube — con UN solo contenido multiplicado en minutos.'
  }, {
    title: 'Nunca más sin ideas',
    desc: 'La Matriz de Contenido Infinito genera 30 ideas virales en menos de 10 minutos, cada semana.'
  }, {
    title: 'Sistema que escala contigo',
    desc: 'No importa qué herramienta de IA salga mañana. El método R.I.C.E. funciona con todas.'
  }];
  return <section className="py-28 px-6 bg-darker text-center" data-id="element-39">
      <div className="max-w-[1000px] mx-auto" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-41">
          <span className="inline-block text-orange text-xs font-bold tracking-[2px] uppercase mb-4" data-id="element-42">
            Tu nueva realidad
          </span>
          <h2 className="text-[clamp(28px,4vw,48px)] font-black mb-4 max-w-[700px] mx-auto text-white" data-id="element-43">
            Imagina tu próximo lunes
          </h2>
          <p className="text-lg text-[#AAAAAA] max-w-[600px] mx-auto mb-[60px]" data-id="element-44">
            Después de un sábado de 4 horas con tu Fábrica de Contenido:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-45">
          {benefits.map((benefit, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: i * 0.1
        }} className="bg-cardBg border border-border rounded-2xl p-7 text-left transition-all duration-300 hover:border-[rgba(255,107,0,0.4)] hover:-translate-y-1" data-id="element-46">
              <div className="w-10 h-10 bg-[rgba(0,210,106,0.15)] border border-[rgba(0,210,106,0.3)] rounded-full flex items-center justify-center text-[18px] text-green mb-4" data-id="element-47">
                ✓
              </div>
              <h3 className="text-[17px] font-bold mb-2 text-white" data-id="element-48">
                {benefit.title}
              </h3>
              <p className="text-[14px] text-[#888] leading-[1.6]" data-id="element-49">
                {benefit.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}